import type { Atom, AtomMut } from '@reatom/framework'

export const isAtomMut = <T>(atom: Atom<T>): atom is AtomMut<T> => {
  return typeof atom === 'function'
}
